import { ReactNode, useCallback, useMemo, useState } from 'react';
import { uiContext } from './uiContext';

export const UIProvider = ({ children }: { children: ReactNode }) => {
  const [isShow, setIsShow] = useState(false);
  const hide = useCallback(() => setIsShow(false), [setIsShow]);
  const show = useCallback(() => setIsShow(true), [setIsShow]);

  const value = useMemo(() => ({ hide, show, isShow }), [hide, show, isShow]);

  return <uiContext.Provider value={value}>{children}</uiContext.Provider>;
};
